import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const HeaderLinks = ({ onClickClose }) => {
  const [t] = useTranslation();

  return (
    <IconButton fontSize='medium' color='transparent' tooltip={t('GenericFilterParam.GenericFilter.BackToList')} onClick={onClickClose}>
      <ArrowBack />
    </IconButton>
  );
};

HeaderLinks.propTypes = {
  onClickClose: PropTypes.func.isRequired
};

export default HeaderLinks;
